module.exports = __webpack_public_path__ + "static/img/2021.1944ba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2021.png
// module id = /eV+
// module chunks = 1